import PipelinePresentationTable from './presentationTable/PipelinePresentationTable'
import PipelinePivotTable from './presentationTable/PipelinePivotTable'
import PipelineComponentLine from './dataviz/ComponentLine'
import PipelineAsOfDatePicker from './asOfDatePicker'
import PipelineQuickDatePicker from './quickDatePicker'
import PipelineCustomDatePicker from './customDatePicker'
import PipelineMiniMetric from './metrics/MiniMetric'
import PipelineComponentMultiLine from './dataviz/ComponentMultiLine'
import PipelinePieChart from './dataviz/ComponentPie'
import PipelineMetric from './metrics/Metric'
import PipelineAllocationList from './dataviz/AllocationList'
import PipelineGauge from './dataviz/Gauge'
import PipelineTagList from './lists/PipelineTagList'
import DDPActivityList from './lists/PipelineActivityList'
import DDPComponentBar from './dataviz/ComponentBar'
import DDPComponentFunnel from './dataviz/ComponentFunnel'
import DDPComponentScatter from './dataviz/ComponentScatter'
import DDPComponentTreeMap from './dataviz/ComponentTreeMap'
import DDPComponentMarkers from './dataviz/ComponentMarkers'
import DDPMetricRing from './dataviz/MetricRing'
import DDPDataProvider from './provider/DDPDataProvider'
import DDPDebug from './utility/DDPDebug'
import DDPLoader from './utility/DDPLoader'
import DDPPhoneWidget from './widgets/DDPPhoneWidget'
import DDPEmailWidget from './widgets/DDPEmailWidget'
import DDPText from './widgets/DDPText'
import DDPRepeater from './widgets/DDPRepeater'
import DDPMarkup from './widgets/DDPMarkup'
import DDPMarkupList from './widgets/DDPMarkupList'
import DDPTag from './widgets/DDPTag'
import DDPValueProvider from './provider/DDPValueProvider'
import PipelineChartGraphic from './dataviz/ComponentGraphic'
import { FilterGroup, FilterSelector } from './filterGroup'
import PipelineVisualBlocks from './dataviz/VisualBlocks/Blocks'
import PipelineVisualBlockList from './dataviz/VisualBlocks/VisualBlockList'
import DDPReportProvider from './report/DDPReportContext'
import DDPReportGrid from './report/DDPReportGrid'
import DDPReportSearch from './report/DDPReportSearch'
import DDPReportLoader from './report/DDPReportLoader'
import DDPReportIndexedDBProvider from './report/indexeddb/DDPReportIndexedDBContext'
import { DDPReportIndexedDBGrid, DDPReportIndexedDBLoader, DDPReportIndexedDBSearch } from './report/indexeddb'
import DDPWealthJourneyEntryList from './wealthJourney/EntryList/DDPWealthJourneyEntryList'
import DDPWealthJourneyEntryListItem from './wealthJourney/EntryList/DDPWealthJourneyEntryListItem'
import DDPWealthJourneyContent from './wealthJourney/EntryList/DDPWealthJourneyContent'
import DDPWealthJourneyCategory from './wealthJourney/DDPWealthJourneyCategory'
import DDPWealthJourneyCategoryGrid from './wealthJourney/DDPWealthJourneyCategoryGrid'
import { HideWhen, ShowWhen } from './when'
import DDPCategoryAxis from './dataviz/DDPCategoryAxis'

const abundanceEngineExports = {
  /** Data Provider */
  DDPDataProvider,
  DDPValueProvider,

  /** Tables */
  DDPTable: PipelinePresentationTable,
  DDPPivotTable: PipelinePivotTable,

  /** This is more of a full feature report component */
  DDPReportProvider: DDPReportProvider,
  DDPReportGrid: DDPReportGrid,
  DDPReportSearch: DDPReportSearch,
  DDPReportLoader: DDPReportLoader,
  /** Variant powered by indexeddb */
  DDPReportIndexedDBProvider,
  DDPReportIndexedDBGrid,
  DDPReportIndexedDBLoader,
  DDPReportIndexedDBSearch,

  /** Data Viz */
  DDPComponentLine: PipelineComponentLine,
  DDPComponentMultiLine: PipelineComponentMultiLine,
  DDPComponentBar,
  DDPComponentScatter,
  DDPComponentTreeMap,
  DDPComponentMarkers,
  DDPComponentFunnel,
  DDPComponentPie: PipelinePieChart,
  DDPMetricRing,
  DDPComponentGraphic: PipelineChartGraphic,
  DDPAllocationList: PipelineAllocationList,
  DDPGauge: PipelineGauge,
  DDPVisualBlocks: PipelineVisualBlocks,
  DDPVisualBlockList: PipelineVisualBlockList,
  DDPCategoryAxis: DDPCategoryAxis,

  /** Utility */
  DDPHideWhen: HideWhen,
  DDPShowWhen: ShowWhen,
  DDPAsOf: PipelineAsOfDatePicker,
  DDPQuickDatePicker: PipelineQuickDatePicker,
  DDPCustomDatePicker: PipelineCustomDatePicker,
  DDPFilterSelectorGroup: FilterGroup,
  DDPFilterSelector: FilterSelector,
  DDPLoader,
  DDPDebug,

  /** Metrics */
  DDPMiniMetric: PipelineMiniMetric,
  DDPMetric: PipelineMetric,

  /** Other */
  DDPTagList: PipelineTagList,
  DDPTag,
  DDPActivityList,
  DDPPhoneWidget,
  DDPEmailWidget,
  DDPText,
  DDPRepeater,
  DDPMarkup,
  DDPMarkupList,

  /** Wealth Journey */
  DDPWealthJourneyEntryList,
  DDPWealthJourneyEntryListItem,
  DDPWealthJourneyContent,
  DDPWealthJourneyCategory,
  DDPWealthJourneyCategoryGrid
}

export default abundanceEngineExports
